import React from 'react';
import type { Panel } from '@/types/dashboard';
import { t } from '@/i18n';
import { IndicatorSettings } from './IndicatorSettings';
import { LabeledListSettings } from './LabeledListSettings';
import { ChartSettings } from './ChartSettings';
import { ChatSettings } from './ChatSettings';

interface EditorSettingsProps {
  panel: Panel;
  onConfigChange: (config: Record<string, unknown>) => void;
  onTitleChange: (title: string) => void;
}

export function EditorSettings({ panel, onConfigChange, onTitleChange }: EditorSettingsProps) {
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onTitleChange(e.target.value);
  };

  return (
    <div>
      <div className="mb-3">
        <label className="form-label">{t('dashboard.panelTitle')}</label>
        <input
          type="text"
          className="form-control"
          data-testid="editor-settings-title"
          value={panel.title ?? ''}
          onChange={handleTitleChange}
        />
      </div>

      {panel.type === 'indicator' && (
        <IndicatorSettings config={panel.config} onConfigChange={onConfigChange} />
      )}
      {panel.type === 'labeled_list' && (
        <LabeledListSettings config={panel.config} onConfigChange={onConfigChange} />
      )}
      {panel.type === 'chart' && (
        <ChartSettings config={panel.config} onConfigChange={onConfigChange} />
      )}
      {panel.type === 'chat' && (
        <ChatSettings config={panel.config} onConfigChange={onConfigChange} />
      )}
    </div>
  );
}
